module.exports = "/fonts/Lato-Regular.ttf";